import { EMPTY_STRING } from '../constants/grimsby';

/**
 * Method to format seconds since epoch to UTC string
 */
const formatDate = (timestamp: number | Date): string => {
    if (timestamp instanceof Date) {
        return timestamp.toUTCString().slice(5, -13);
    } else if (typeof timestamp === 'number') {
        return new Date(timestamp).toUTCString().slice(5, -13);
    } else {
        return EMPTY_STRING;
    }
};

export const encodeDateNumber = (dateNumber: number) =>
    Math.floor(dateNumber / 1000);

export const decodeDateNumber = (dateNumber: number) => dateNumber * 1000;

/**
 * Format a UNIX timestamp (seconds since epoch) to full 24h UTC string.
 * Example: 1715181720 -> "2026-05-08 15:22:00 UTC"
 */
export const formatTimestampUTC = (seconds: number): string => {
    const date = new Date(seconds * 1000);
    // new Date(NaN).toISOString() throws RangeError. Guard so a single
    // malformed/missing timestamp cannot crash the audit table or export.
    if (isNaN(date.getTime())) {
        return EMPTY_STRING;
    }
    return date
        .toISOString()
        .replace('T', ' ')
        .replace(/\.\d+Z$/, ' UTC');
};

export default formatDate;
